import {styled} from "@mui/material/styles";

export const TableWrapper = styled("div")({
  backgroundColor: "white",
  borderRadius: "4px",
  overflow: "hidden"
});
